"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionLikeEnvironment = void 0;
const neo_tax_environment_enum_1 = require("./enums/neo-tax-environment.enum");
/**
 * @returns true if environment is production-like
 */
const isProductionLikeEnvironment = (neoTaxEnvironment) => [
    neo_tax_environment_enum_1.NeoTaxEnvironment.PRODUCTION,
    neo_tax_environment_enum_1.NeoTaxEnvironment.THOMSON_REUTERS,
    neo_tax_environment_enum_1.NeoTaxEnvironment.NARVAR,
    neo_tax_environment_enum_1.NeoTaxEnvironment.ZELIS,
    neo_tax_environment_enum_1.NeoTaxEnvironment.NBH,
    neo_tax_environment_enum_1.NeoTaxEnvironment.ADOBE,
    neo_tax_environment_enum_1.NeoTaxEnvironment.LENDINGCLUB,
    neo_tax_environment_enum_1.NeoTaxEnvironment.CAPITALONE,
    neo_tax_environment_enum_1.NeoTaxEnvironment.BULLHORN,
    neo_tax_environment_enum_1.NeoTaxEnvironment.DEMO,
    neo_tax_environment_enum_1.NeoTaxEnvironment.QUALCOMM,
    neo_tax_environment_enum_1.NeoTaxEnvironment.EXPEDIA,
    neo_tax_environment_enum_1.NeoTaxEnvironment.SHELL,
].includes(neoTaxEnvironment);
exports.isProductionLikeEnvironment = isProductionLikeEnvironment;
